import React, { useState } from "react";

interface Tracker {
  id: number;
  realAngle: number;
  targetAngle: number;
}

export function TrackersView({
  setViewTrackers,
  device,
}: {
  setViewTrackers: (view: any) => void;
  device: any;
}) {
  return (
    <div>
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
        <div className="bg-white p-6 rounded shadow-lg w-full max-w-4xl">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">Trackers</h2>
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={() => setViewTrackers(null)}
            >
              Fechar
            </button>
          </div>
          <p className="text-gray-600 mb-4">
            Visualização dos ângulos reais e alvo dos trackers solares.
          </p>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
            {device.trackers.map((tracker: any) => (
              <div
                key={tracker.sn}
                className="flex flex-col items-center border p-2 rounded"
              >
                <h3 className="text-lg font-semibold mb-2">{tracker.name}</h3>
                <svg width="100" height="100" viewBox="0 0 100 100">
                  {/* Base vertical do tracker */}
                  <line
                    x1="50"
                    y1="50"
                    x2="50"
                    y2="100"
                    stroke="black"
                    strokeWidth="4"
                  />
                  {/* Parte superior do tracker */}
                  <g transform={`rotate(${tracker.last_state?.posAg}, 50, 50)`}>
                    <line
                      x1="10"
                      y1="50"
                      x2="90"
                      y2="50"
                      stroke="black"
                      strokeWidth="4"
                    />
                  </g>
                </svg>
                <div className="text-sm mt-2">
                  <p>Ângulo Real: {tracker.last_state?.posAg.toFixed(2)}°</p>
                  <p>Ângulo Alvo: {tracker.last_state?.posAl.toFixed(2)}°</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
